import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosPreagendamientoEnumChoice, ROUTER_PATHS } from "@/shared";
import { useGetPreagendamiento } from "@/shared/actions/erp";
import { useCheckPermissions, useLoaders } from "@/shared/hooks";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { ConfirmPreagendamiento } from "../../shared/components";

export type UpdatePreagendamientoPageProps = {};

const UpdatePreagendamientoPage: React.FC<
  UpdatePreagendamientoPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_preagendamiento);
  const setAlert = useUiStore((s) => s.setAlert);
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetPreagendamiento(id!);

  useLoaders(isLoading);

  useEffect(() => {
    if (isLoading || isRefetching) return;

    if (
      !!data &&
      data?.data?.estado_preagendamiento !==
        EstadosPreagendamientoEnumChoice.EN_ESPERA &&
      data?.data?.estado_preagendamiento !==
        EstadosPreagendamientoEnumChoice.EN_PAUSA
    ) {
      setAlert(
        true,
        "La solicitud no se encuentra en estado correcto",
        AlertSeverityEnum.error
      );
    }
  }, [data, isLoading, isRefetching]);

  if (isLoading) return null;

  if (
    !data?.data?.id_preagendamiento ||
    (data?.data?.estado_preagendamiento !==
      EstadosPreagendamientoEnumChoice.EN_ESPERA &&
      data?.data?.estado_preagendamiento !==
        EstadosPreagendamientoEnumChoice.EN_PAUSA)
  )
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <ConfirmPreagendamiento
      title="Confirmar Agendamiento PYL"
      preagendamiento={data.data}
    />
  );
};

export default UpdatePreagendamientoPage;
